module.exports = __webpack_public_path__ + "img/badge_rimborsi_main_level.e90a0f69.jpg";